export enum EscalationState {
    Open = 'open',
    ToTriage = 'to-triage',
    Waiting = 'waiting',
    SolutionSubmitted = 'solution-submitted',
    Closed = 'closed',
    Lost = 'lost',
}
